import * as React from 'react';
import colors from 'app/util/colors';

/* @jsxImportSource @emotion/react */  import { css, jsx } from '@emotion/react'; /* eslint-disable-line */

const style = css`
    display: inline-block;
    color: white;

    div {
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
		border: 2px solid white;
    }
`;

const sumChars = (str) => {
    let sum = 0;
    for (let i = 0; i < str.length; i++) {
        sum += str.charCodeAt(i);
    }

    return sum;
}

const LetterAvatar = props => {
    const {
        borderRadius = '100%',
        name,
        className
    } = props;

    let initials = "";
    let background;

    if (name) {
        const nameSplit = String(name).toUpperCase().replace('  ', ' ').split(' ');
        if (nameSplit.length === 1) {
            initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
        } else if (nameSplit.length === 3)  {
            initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0) + nameSplit[2].charAt(0);
        } else {
            initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
        }

        background = colors[sumChars(name) % colors.length];
    } else {
        initials = "UN";
        background = colors[0];
    }


    const size = props.size + "px";
    const innerSize = (props.size - 4) + "px";

    const imageStyle = {
        display: 'block',
        borderRadius
    };

    const innerStyle = {
        lineHeight: innerSize,
        textAlign: 'center',
        borderRadius
    };

    if (size) {
		innerStyle.width = size;
		innerStyle.height = size;
		innerStyle.fontSize = (props.size / initials.length)+"px";

        imageStyle.width = innerSize;
        imageStyle.height = innerSize;
    }

    let inner, classes = [className, 'LetterAvatar'];

    innerStyle.backgroundColor = background;

    inner = initials;

    return (
        <div css={style} aria-label={name} className={classes.join(' ')}>
            <div style={innerStyle}>
                {inner}
            </div>
        </div>
    )
}

export default LetterAvatar;